import mergeWith from 'lodash/mergeWith';
import uniqBy from 'lodash/uniqBy';

import {
  SECTION_OVERRIDES_FIELD,
  SECTIONS_FIELD_V2,
  TEMPLATE_FIELD_V2,
} from '@glass/web/modules/resumes/fieldKeys';

const customMerge = (objValue, srcValue, key) => {
  switch (key) {
    case SECTION_OVERRIDES_FIELD:
      return srcValue;
    case TEMPLATE_FIELD_V2:
      return srcValue || objValue;
    default:
      break;
  }
  if (Array.isArray(objValue) && Array.isArray(srcValue)) {
    switch (key) {
      case SECTIONS_FIELD_V2:
        // eslint-disable-next-line no-case-declarations
        const newObj = [...objValue];
        // eslint-disable-next-line no-case-declarations
        const mergedObj = srcValue.map(({ type, ...other }) => {
          const sameObjIndex = newObj.findIndex((itm) => itm.type === type);
          // already in array
          if (sameObjIndex > -1) {
            // get current obj will removing it
            const sameObj = newObj.splice(sameObjIndex, 1);
            return {
              ...sameObj[0],
              ...other,
            };
          }
          // adding section to resume for first time, it might be a good place to set defaults
          return {
            type,
            ...other,
          };
        });
        return uniqBy([...newObj, ...mergedObj], 'type');
      default:
        return srcValue;
    }
  }
  return undefined;
};

// NOTE: mergeWith mutates the first object which produces some serious side effects
const mergeResumes = (...args) => mergeWith(...args, customMerge);

export default mergeResumes;
